import { gql } from '~src/generated/portal/gql';

const GET_DEVICES = gql(`
  query getDevices($projectId: String!) {
    devices(filter: { projectId: $projectId }) {
      id
      alias
      acquired
      underTest
      status
      firmwareVersion
      user {
        id
        lastName
        firstName
      }
      testStatus {
        test {
          id
          cacheId
        }
      }
    }
  }
`);

export default GET_DEVICES;
